import React, { useState } from "react";
import Lightbox from "../gallery/Lightbox";

/**
 * ตารางรูปแนบของ VOC — ภาพย่อโชว์ทั้งรูป (ไม่ crop) บนพื้นเทาอ่อน
 * กดรูปไหนก็เปิดดูเต็มจอ เลื่อนดูรูปอื่นได้ ปิดได้ (ไม่เปิดแท็บใหม่)
 *
 * images: [{ src, name }]  (src เป็น URL เต็ม — ไฟล์จาก Strapi หรือ blob ของไฟล์ที่ยังไม่ส่ง)
 * renderExtra(i): ของที่ซ้อนบนภาพย่อ เช่นปุ่มลบในหน้าอัปโหลด
 */
export default function VocImageGrid({
  images,
  className = "grid grid-cols-3 gap-[10px]",
  tileClassName = "aspect-square rounded-[8px]",
  children,
  renderExtra,
  lang,
}) {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <>
      <div className={className}>
        {images.map((img, i) => (
          <div
            key={`${img.name}-${i}`}
            className={`relative overflow-hidden border-[1px] border-cardBorder bg-lightGray3 ${tileClassName}`}
          >
            <button
              type="button"
              className="w-full h-full cursor-zoom-in"
              aria-label={img.name || (lang === "en" ? "View image" : "ดูรูป")}
              onClick={(e) => {
                e.stopPropagation();
                setOpenIndex(i);
              }}
            >
              <img src={img.src} alt={img.name || ""} className="w-full h-full object-contain" />
            </button>
            {renderExtra && renderExtra(i)}
          </div>
        ))}
        {children}
      </div>

      {openIndex !== null && images[openIndex] && (
        <Lightbox
          images={images}
          index={openIndex}
          onChange={setOpenIndex}
          onClose={() => setOpenIndex(null)}
          lang={lang}
        />
      )}
    </>
  );
}
